const ANALYTICS_EVENT_TYPES = {
    LOGIN: 'login',
    LICENSE_ACTIVATED: 'license-activated',
    MODULE_ACCESSED: 'module-accessed',
    NODE_ACCESSED: 'node-accessed',
    MEDIALINK_ACCESSED: 'medialink-accessed',
    APP_ACCESSED: 'app-accessed',
    DIGIBOOK_ACCESSED: 'digibook-accessed',
    DIGIBOOK_PAGE_ACCESSED: 'digibook-page-accessed',
    USER_MATERIAL_CREATED: 'user-material-created',
    USER_MATERIAL_ACCESSED: 'user-material-accessed',
    USER_WHITEPAGE_CREATED: 'user-whitepage-created',
    USER_WHITEPAGE_ACCESSED: 'user-whitepage-accessed',
};

export { ANALYTICS_EVENT_TYPES };
